// extracted by mini-css-extract-plugin
export default {"grid":"Calendar_grid_At5o_","loader":"Calendar_loader_a2dOK"};